module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("Calm as that second summer which precedes")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("The first fall of the snow,")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("In the broad sunlight of heroic deeds,")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("The City bides the foe.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—Henry Timrod, “Charleston”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 66
// module chunks = 0